// extracted by mini-css-extract-plugin
export default {"header":"style_header__6pPcG","headerContent":"style_headerContent__dCfTd"};